import { History } from "lucide-react";

import { RestoreButton } from "@/shared/components/RestoreButton";
import { Counted, ListCard, ListRow, ListTile } from "@/shared/components/ListCard";
import { Pane, StatusBadge } from "@/shared/components/settings-atoms";
import { toVersions, useAgentVersions } from "@/shared/api/agents";

import type { Agent } from "@/shared/types";

/* Every published version, newest first. Restore has no endpoint yet. */
export default function VersionsSection({ agent }: { agent: Agent }) {
  const { data } = useAgentVersions(agent.id);
  const versions = data ? toVersions(data, agent.version) : [];

  return (
    <Pane title="Versions" desc="Every published version of this agent.">
      <ListCard className="mt-6" label={<Counted n={versions.length} noun="version" />}>
        {versions.map((v) => (
          <ListRow
            key={v.id}
            lead={<ListTile><History className="w-4 h-4" strokeWidth={1.75} /></ListTile>}
            title={
              <span className="inline-flex items-center gap-2">
                <span className="font-mono">{v.id}</span>
                {v.current && <StatusBadge tone="success">Current</StatusBadge>}
              </span>
            }
            desc={v.label}
          >
            <span className="shrink-0 text-[12px] text-[var(--text-tertiary)]">{v.when}</span>
            {!v.current && <RestoreButton disabled title="Restore isn't available yet" />}
          </ListRow>
        ))}
      </ListCard>
    </Pane>
  );
}
